// API Configuration
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const API_CHATBOT_BASE_URL = process.env.REACT_APP_CHATBOT_BASE_URL;
// Storage Keys
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'gurukul_auth_token',
  USER_DATA: 'gurukul_user_data',
  REFRESH_TOKEN: 'gurukul_refresh_token',
};

// User Roles
export const USER_ROLES = {
  USER: 'USER',
  ADMIN: 'ADMIN',
  FINANCE_ADMIN: 'FINANCE_ADMIN',
  CONTENT_ADMIN: 'CONTENT_ADMIN',
  SUPPORT_ADMIN: 'SUPPORT_ADMIN',
  CANDIDATE: 'CANDIDATE', // legacy but used in backend response for roles
  GURUKUL: 'CANDIDATE', // mapping to the same backend role for now if applicable
};

// KYC Status
export const KYC_STATUS = {
  OPEN: 'OPEN',
  UNDER_REVIEW: 'UNDER_REVIEW',
  VERIFIED: 'VERIFIED',
  REJECTED: 'REJECTED',
};

// Donation Status
export const DONATION_STATUS = {
  PENDING: 'PENDING',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED',
};

// Target Types
export const TARGET_TYPES = {
  PARTY: 'PARTY',
  GURUKUL: 'CANDIDATE',
};

// Payment methods – only Voucher (values match backend)
export const PAYMENT_METHODS = [
  { id: 'VOUCHER', label: 'Voucher Payment', description: 'Pay via Bank Voucher' },
];

// Donation Limits
export const DONATION_LIMITS = {
  MIN: 10,
  MAX: 100000000, // Effectively infinite (10 Crores)
};

// Pagination
export const PAGINATION = {
  DEFAULT_LIMIT: 10,
  DEFAULT_OFFSET: 0,
  MAX_LIMIT: 100,
};
